import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { SharedService } from '../../home/shared.service';
import { AlertService } from '../../util/alert/alert.service';
import { KnowledgeTagService } from './knowledgetag.service';
import { UserService } from '../../user/user.service';
import { NoWhitespaceDirective } from "../../util/validator/nowhitespace.directive"
import { SanitizationService } from '../../sanitizer.service';
@Component({
	selector: 'app-addknowledgetag',
	templateUrl: './addknowledgetag.component.html'
})

export class AddKnowledgeTagComponent implements OnInit {
	addKnowledgeTag: FormGroup;
	constructor(private router: Router,
		private sharedService: SharedService,
		private alertServices: AlertService,
		private knowledgeTagService: KnowledgeTagService,
		private userService: UserService,
		private sanitizer: SanitizationService
	) {
		if (!userService.isValidLoggedIn()) {
			userService.redirectToLoginScreen();
		}

	}

	ngOnInit() {
		this.addKnowledgeTag = new FormGroup({
			knowledgeTag: new FormControl(null, Validators.required)
		});
	}

	cancel() {
		this.sharedService.change('KnowledgeTag');
	}

	saveAndNew() {

		this.knowledgeTagService.addKnowledgeTag(this.sanitizer.sanitize(this.addKnowledgeTag.value.knowledgeTag))
			.subscribe(
			data => {
				this.alertServices.clear();
				this.alertServices.success("Successfully added the knowledge tag.");
				// this.addKnowledgeTag.reset();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	save() {

		this.knowledgeTagService.addKnowledgeTag(this.sanitizer.sanitize(this.addKnowledgeTag.value.knowledgeTag))
			.subscribe(
			data => {
				this.alertServices.clear();
				this.cancel();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

}
